import { Component, OnInit, Input } from '@angular/core';
import { MessengerService, MessageSubject } from 'src/app/core/service/messenger.service';
import { CaseService } from 'src/app/core/service/case.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/core/service/user.service';
import { sortBy } from 'lodash';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';

@Component({
  standalone: false,
  selector: 'app-case-assign',
  templateUrl: './case-assign.component.html',
  styleUrls: ['./case-assign.component.scss']
})
export class CaseAssignComponent implements OnInit
{
  /**
   * The case to assign.
   */
  @Input() public aCase;

  /**
   * Case manager assignee form.
   */
  public caseManagerForm: UntypedFormGroup;

  /**
   * Users that are part of the group for this case's channel.
   */
  public channelStaff = [];

  /**
   * Filtered users
   */
  public channelStaffFiltered = [];

  /**
   * Current search term entered from a comboxbox
   */
  public searchTerm: string;

  /**
   * Constructor
   */
  constructor(
    private messengerService: MessengerService,
    private caseService: CaseService,
    private userService: UserService,
    private messageHandlerService: MessageHandlerService)
  { }

  public ngOnInit(): void
  {
    // get channel staff group
    this.userService.getUsersByCase(this.aCase.id).subscribe({
      next: (users) =>
      {
        this.channelStaff = users;
        this.caseManagerFilter('');
      }
    });

    // initialize the form group for case manager
    this.caseManagerForm = new UntypedFormGroup(
      {
        assignee: new UntypedFormControl(null, Validators.required),
        reassignOpenTasks: new UntypedFormControl(true),
        reasonForReassign: new UntypedFormControl(null, Validators.required)
      });
  }

  /**
   * Filter handler for case manager assign dropdown.
   *
   * @param value User input.
   */
  public caseManagerFilter(value: string): void
  {
    this.searchTerm = value;
    this.channelStaffFiltered = sortBy(this.channelStaff.filter(p => p.name.toLowerCase().includes(value.toLowerCase())), ['name']);
  }

  /**
   * Save the new case manager.
   */
  public save(): void
  {
    const manager = this.caseManagerForm.get('assignee').value;
    const reason = this.caseManagerForm.get('reasonForReassign').value;
    const reassignOpenTasks = this.caseManagerForm.get('reassignOpenTasks').value;

    // call case service to save the case.
    const updateManager: any = {};
    updateManager.userId = manager.id;
    updateManager.reason = reason;
    updateManager.reassignOpenTasks = reassignOpenTasks;
    this.caseService.updateCaseManager(this.aCase.id, updateManager).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess('CASE-MANAGER-UPDATED-SUCCESSFULLY');
        // send a message to other components.
        this.messengerService.sendMessage(new MessageSubject('caseManagerUpdated',
          {
            id: manager.id, name: manager.name, caseId: this.aCase.id
          }));
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  /**
   * Check if user from dropdown is disabled or enabled.
   *
   * @returns boolean
   */
  public itemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.enabled && !itemArgs.dataItem.inRegistration;
  }
}
